import React from 'react';
import { CloseSharp } from '@mui/icons-material';
import Timeseries from './Timeseries';
import { NEARBY_GAUGES_RADIUS, formatDateString } from './utils';
import { useSessionContext } from './SessionContext';

const distanceFromClosestGauge = (nearbyGauges) => {
  if (!nearbyGauges || !nearbyGauges.length) return `>${NEARBY_GAUGES_RADIUS} miles`;

  const closestGauge = nearbyGauges.sort((a, b) => a.distance - b.distance)[0];

  // string slicing for sig-fig effect, i.e. 123/12.3/1.23 miles
  const formattedDistance = closestGauge.distance.toString().slice(0, 4);

  return `${formattedDistance} miles`;
};

const formatWLI = (frame) => {
  if (!frame) return '--';
  return frame;
};

export default function LocationPanel() {
  const {
    selectedLocation, clearSelectedLocation, nearbyGauges, dates, selectedArea,
    discreteSelectedDateIndex
  } = useSessionContext();

  return (
    <div className="frosted">
      <div style={{
        display: 'flex',
        alignItems: 'center'
      }}
      >
        <div style={{
          margin: '8px', fontSize: '18px', fontWeight: 'bold', flexGrow: 2
        }}
        >
          <span>{selectedLocation.name}</span>
        </div>
        <div
          onClick={clearSelectedLocation}
          style={{
            cursor: 'pointer',
            display: 'flex',
            justifyContent: 'center',
            alignItems: 'center'
          }}
        >
          <CloseSharp style={{ margin: '8px' }} />
        </div>

      </div>
      <hr style={{ margin: '0 8px 0', border: '1px solid var(--gray0)' }} />
      <div style={{ margin: '8px', fontSize: '17px' }}>
        {nearbyGauges && (
          <>
            <div className="split-spans">
              <span>{`Gauges within ${NEARBY_GAUGES_RADIUS} miles`}</span>
              <b>{nearbyGauges.length}</b>
            </div>
            <div className="split-spans">
              <span>Closest gauge</span>
              <b>{distanceFromClosestGauge(nearbyGauges)}</b>
            </div>
          </>
        )}
        {dates && selectedArea && (
          <div className="split-spans">
            <span>{`WLI on ${formatDateString(dates[discreteSelectedDateIndex])}`}</span>
            <b>{formatWLI(selectedArea.timeline[discreteSelectedDateIndex || 0])}</b>
          </div>
        )}
        <Timeseries />
      </div>

    </div>
  );
}
